module.exports = __webpack_public_path__ + "img/formacao_personalizada.f486ce8f.svg";